import { useQueryParams } from '@hooks/queryParams';
import { ApiError } from '@root/globalTypes';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { UsersDropdownRespSuccess } from '../types';
import { UsersDropdownProps } from './types';
import { useAppContext } from '@contexts/app';

export const useUsersDropdown = ({
  role,
  primaryRole,
  specialty,
  divisionId,
  divisionIds: divisionIdsOverride,
  strictDivisionFilter,
  active,
}: UsersDropdownProps) => {
  const { isDropdownEnabled: enabled } = useAppContext();

  const {
    params: { divisionIds: urlDivisionIds },
    parseParams,
  } = useQueryParams();

  const resolvedDivisionIds = divisionId ? [divisionId] : (divisionIdsOverride ?? urlDivisionIds);

  const queryParams = parseParams(
    {
      role,
      primaryRole,
      specialty,
      divisionIds: resolvedDivisionIds,
      strictDivisionFilter,
      active,
    },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<UsersDropdownRespSuccess, ApiError>({
    queryKey: [...queryKeys.dropdowns.users.index, queryParams],
    queryFn: () => queryFetch({ url: `dropdowns/users${queryParams}` }),
    placeholderData: (previousData) => previousData as UsersDropdownRespSuccess,
    enabled,
    retry: 2,
  });

  return {
    data,
    error,
    isLoading: isPending && enabled,
  };
};
